import { lazy } from 'react';
const ProformaInvoiceExistingCust = lazy(() => import('./ProformaInvoiceExistingCust'));

const ProformaInvoiceExistingCustRoutes = [
  {
    path: '/proinvexcust',
    component: ProformaInvoiceExistingCust
  }
];

export default ProformaInvoiceExistingCustRoutes;
